module.exports = __webpack_public_path__ + "img/ic_20_report.8127855c.svg";